import { getQueryStringParameters } from './query-utils';
import { IRawAppPayload } from '../state-management/types';
import { FeatureFlag, FeatureFlags } from '../types';

type QueryStringPayload = Partial<Omit<IRawAppPayload, 'featureFlags'>> & { 'featureFlags[]': string[] };

type FeatureFlagQueryKey = 'challenge-store';
const featureFlagMap: Map<FeatureFlagQueryKey, FeatureFlag> = new Map([['challenge-store', FeatureFlag.Challenges]]);

/*
  Converts query params that don't map cleanly to the IRawAppPayload, e.g.:
    - array-like query params to a JS object ("featureFlags[]" => featureFlags)
*/
const convertPayload = (queryStringPayload: QueryStringPayload): Partial<IRawAppPayload> => {
  const { ['featureFlags[]']: flags, ...payload } = queryStringPayload;
  const enabledFlags = flags ?? [];
  const featureFlagConfig: Partial<FeatureFlags> = enabledFlags.reduce((accum, flag) => {
    const featureFlagEnum: FeatureFlag | null = featureFlagMap.get(flag as FeatureFlagQueryKey);

    if (featureFlagEnum == null) {
      return accum;
    }

    return {
      ...accum,
      [featureFlagEnum]: true,
    };
  }, {});

  return {
    ...payload,
    featureFlags: featureFlagConfig,
  };
};

export function trySetupWithQueryStringParams(): void {
  if (window.callJavaScript) {
    const payload = getQueryStringParameters();
    if (payload) {
      const rawAppPayload = convertPayload(payload as unknown as QueryStringPayload);
      window.callJavaScript(JSON.stringify(rawAppPayload));
    }
  }
}
